module.exports = __webpack_public_path__ + "img/img2.90b6953b.png";